import DefaultCell from "application/components/DefaultCell";
import RowAction from "application/components/RowAction";
import formControl from "globals/form-control";
import CampaignGatewayCell from "application/components/campaignGatewayCell";
import CampaignTypeCell from "application/components/campaignTypeCell";
import CampaignAutoAttendantCell from "application/components/campaignAutoAttendantCell";
import { callCenterConfigMenuMoreVert } from "globals/configuration/callCenterConfigMenuMoreVert";


const operationURLS = {
  list: "/campaign/list",
  update: "campaign/update",
  create: "/campaign/create",
  delete: "campaign/delete",
  paste: "/campaign/create",
};

const getColumns = (onUploadLead ,onDelete, onEdit, onCopy, onView) => {
  return [
    {
      Header: "Campaign Name",
      accessor: "description",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      Cell: ({ value }) => <DefaultCell value={value} />,
      validation: formControl.string().required("Required").nullable(),
      width: 6,
    },
    {
      Header: "Campaign Short Code",
      accessor: "shortCode",
      displayInList: true,
      allowInForm: true,
      noneditable: true,
      allowFilter: false,
      dataType: "string",
      Cell: ({ value }) => <DefaultCell value={value} />,
      width: 6,
    },
    {
      Header: "From Date",
      accessor: "fromDate",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      controlType: "date",
      setChange: "toDate",
      Cell: ({ value }) => <DefaultCell value={value} />,
      validation: formControl.string().required("Required").nullable(),
      width: 6,
    },
    {
      Header: "To Date",
      accessor: "toDate",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      controlType: "date",
      Cell: ({ value }) => <DefaultCell value={value} />,
      validation: formControl.string().required("Required").nullable(),
      width: 6,
    },
    {
      Header: "From Time",
      accessor: "fromTime",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      controlType: "time",
      setChange: "toTime",
      Cell: ({ value }) => <DefaultCell value={value} />,
      validation: formControl.string().required("Required").nullable(),
      width: 6,
    },
    {
      Header: "To Time",
      accessor: "toTime",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      controlType: "time",
      Cell: ({ value }) => <DefaultCell value={value} />,
      validation: formControl.string().required("Required").nullable(),
      width: 6,
    },
    {
      Header: "Campaign Type",
      accessor: "campaignType",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "string",
      controlType: "select",
      options: {
        keyField: "id",
        keyDescription: "description",
        values: [
          { id: "0", description: "General" },
          { id: "1", description: "Abandoned" },
          { id: "2", description: "NBH" },
          { id: "3", description: "Blaster" },
          { id: "4", description: "Announcement" },
          { id: "5", description: "Preview Dialing Type 1" },
          { id: "6", description: "Preview Dialing Type 2" },
          { id: "7", description: "Preview Dialing Type 3" },
        ],
      },
      Cell: ({ value }) => <CampaignTypeCell value={value} />,
      validation: formControl.string().required("Required").nullable(),
      width: 6,
    },
    {
      Header: "Autoattendant No",
      accessor: "autoAttendantId",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "string",
      Cell: ({ value }) => <CampaignAutoAttendantCell value={value} />,
      width: 6,

      controlType: "select",
      options: {
        keyField: "id",
        keyDescription: "extension",
        values: [],
        url: "autoAttendant/listAll",
      },
    },
    {
      Header: "Gateway",
      accessor: "gatewayId",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "integer",
      controlType: "select",
      options: {
        keyField: "id",
        keyDescription: "gwCode",
        values: [],
        url: "gateway/listAll",
      },
      Cell: ({ value }) => <CampaignGatewayCell value={value} />,
      validation: formControl.string().required("Required").nullable(),
      width: 12,
    },
    {
      Header: "Action",
      accessor: "id",
      displayInList: true,
      allowInForm: false,
      Cell: ({ row, value }) => (
        <RowAction
          row={row}
          value={value}
          onUploadLead={onUploadLead}
          onDelete={onDelete}
          onEdit={onEdit}
          onCopy={onCopy}
          onView={onView}
        />
      ),
    },
  ];
};

export { getColumns, operationURLS };
